module.exports = __webpack_public_path__ + "assets/img/zhdn.4e43c694.png";